import React, { Component } from 'react';
import { object, func, string, bool } from 'prop-types';
import classnames from 'classnames';
import { translate } from 'react-i18next';
import { inject } from 'mobx-react';
import { Check } from 'wix-ui-icons-common';

import CloseBar from '../close-bar';
import FooterLayout from '../footer-layout';
import styles from './upgrade-modal-layout.scss';

import { Text, Loader, Heading } from 'wix-style-react';

class UpgradeModalLayout extends Component {
  static propTypes = {
    t: func.isRequired,
    appConfig: object.isRequired,
    integrationName: string.isRequired,
    onPrimaryButtonClick: func.isRequired,
    onClose: func.isRequired,
    isLoading: bool.isRequired,
  };

  renderModal = () => {
    const {
      integrationName,
      onClose,
      onPrimaryButtonClick,
      appConfig: { staticsBaseUrl },
      t,
    } = this.props;

    return (
      <div data-hook="upgrade-modal">
        <CloseBar onClose={onClose} />
        <div className={styles.header}>
          <img
            className={styles.illustration}
            src={`${staticsBaseUrl}assets/illustrations/orders-empty-upgrade.png`}
            alt=""
          />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
            <Heading appearance="H2">
              {`${t('premium.connect')} ${t(integrationName)} ${t(
                'premium.to.your.site',
              )}`}
            </Heading>
          </div>
          <div className={styles[`sub-title`]}>
            <Text secondary>{t('premium.upgrade.sub.title')}</Text>
          </div>
          <div className={styles.benefits}>
            {[
              'premium.upgrade.benfit.marketing.integrations',
              'premium.upgrade.benfit.marketing.domain',
              'premium.upgrade.benfit.marketing.remove.ads',
            ].map((benefitKey) => (
              <div key={benefitKey} className={styles.benefit}>
                <span className={styles[`v-icon`]}>
                  <Check />
                </span>
                <Text secondary>{t(benefitKey)}</Text>
              </div>
            ))}
          </div>
        </div>
        <FooterLayout
          size="extra-large"
          primaryButtonLabel={t('premium.upgrade.cta')}
          onPrimaryButtonClick={onPrimaryButtonClick}
          footer={
            <Text size="small" secondary>
              {t('premium.upgrade.money.guarantee')}
            </Text>
          }
          theme="fancy"
        />
      </div>
    );
  };

  render() {
    const { isLoading } = this.props;
    return (
      <div
        data-hook="upgrade-modal-container"
        className={classnames(styles.container, isLoading && styles.loading)}
      >
        {isLoading ? <Loader /> : this.renderModal()}
      </div>
    );
  }
}

export default translate()(inject('appConfig')(UpgradeModalLayout));
